export const gettersMixin = () => {
  return {
    collection: (state) => state.collection,
    children: (state) => state.children,
    selected: (state) => state.selected,
    loading: (state) => state.loading,
    meta: (state) => state.meta,
    appliedFilters: (state) => state.meta.filters,
    sort: (state) => `${state.meta.descending ? '-' : ''}${state.meta.sortBy}`
  }
}
